export const invoicesConstants = {
    emptyCellContentPlaceholder: "-",
} as const;
